module.exports = __webpack_public_path__ + "static/media/motor4.dac38dd6.jpg";